module.exports = __webpack_public_path__ + "static/img/icon46.8a62b80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon46.png
// module id = l131
// module chunks = 1